import React from "react";
import routes, {routesLists} from "../../routes";
import {Redirect, Switch} from "react-router";
import {Route} from "react-router-dom";
import ServerError from "../error/server_error";
import AccessDenied from "../error/access_denied";
import BaseAuthView from "../../containers/base-auth";
import Login from "./login";
import ForgotPassword from "./forgot-password";
import ResetPassword from "./reset-password";
import Logout from "./logout";
import useRouter from "../../hooks/use-router";
import LogoDark from "../../../assets/logos/bizkeytech_dark.png";
import LogoLight from "../../../assets/logos/bizkeytech_light.png";


const AuthViews = () => {
    const {query} = useRouter();
    const colorMode = React.useMemo(() => {
        if (query?.colorMode === 'dark' || query?.colorMode === 'light') {
            return query.colorMode;
        }
        return 'light'
    }, [query?.colorMode])


    React.useEffect(() => {
        if (colorMode === 'light')
            return;
        const document = window?.document;
        if (!document)
            return;
        const documentBodyStyles = {
            backgroundColor: document.body.style.backgroundColor,
            color: document.body.style.color,
        }
        setTimeout(() => {
            document.body.style.setProperty('background-color', '#252525', 'important');
            document.body.style.setProperty('color', '#DEDEDE', 'important');

            const bgWhite = document.querySelectorAll('.bg-white');
            bgWhite.forEach(element => {
                element.classList.remove('bg-white');
                if (element instanceof HTMLElement) {
                    element.style.setProperty('background-color', '#252525', 'important');
                }
            });

            const loginLogo = document.querySelectorAll('.login-logo');
            loginLogo.forEach(element => {
                if (element instanceof HTMLImageElement) {
                    element.src = LogoDark;
                }
            });

            const primaryColorDark = document.querySelectorAll('.primary-color-dark');
            primaryColorDark.forEach(element => {
                element.classList.remove('primary-color-dark');
                if (element instanceof HTMLElement) {
                    element.style.setProperty('color', '#DEDEDE', 'important');
                }
            });

            const buttonTexts = document.querySelectorAll('.MuiButton-text');
            buttonTexts.forEach(element => {
                if (element instanceof HTMLElement) {
                    element.style.setProperty('color', '#DEDEDE', 'important');
                }
            });

            const inputs = document.querySelectorAll('input');
            inputs.forEach(element => {
                if (element instanceof HTMLInputElement) {
                    element.style.setProperty('color', '#DEDEDE', 'important');
                }
            });
            const label = document.querySelectorAll('label');
            label.forEach(element => {
                if (element instanceof HTMLLabelElement) {
                    element.style.setProperty('color', '#DEDEDE', 'important');
                }
            });
        }, 100)

        return () => {
            document.body.style.setProperty('background-color', documentBodyStyles.backgroundColor, 'important');
            document.body.style.setProperty('color', documentBodyStyles.color, 'important');

            const bgWhite = document.querySelectorAll('.bg-white');
            bgWhite.forEach(element => {
                element.classList.add('bg-white');
                if (element instanceof HTMLElement) {
                    element.style.removeProperty('background-color');
                }
            });
            const loginLogo = document.querySelectorAll('.login-logo');
            loginLogo.forEach(element => {
                if (element instanceof HTMLImageElement) {
                    element.src = LogoLight;
                }
            });
            const primaryColorDark = document.querySelectorAll('.primary-color-dark');
            primaryColorDark.forEach(element => {
                element.classList.add('primary-color-dark');
                if (element instanceof HTMLElement) {
                    element.style.removeProperty('color');
                }
            });
            const buttonTexts = document.querySelectorAll('.MuiButton-text');
            buttonTexts.forEach(element => {
                if (element instanceof HTMLElement) {
                    element.style.removeProperty('color');
                }
            });
            const inputs = document.querySelectorAll('input');
            inputs.forEach(element => {
                if (element instanceof HTMLInputElement) {
                    element.style.removeProperty('color');
                }
            });
            const label = document.querySelectorAll('label');
            label.forEach(element => {
                if (element instanceof HTMLLabelElement) {
                    element.style.removeProperty('color');
                }
            });
        }
    }, [colorMode])


    return (
        <BaseAuthView>
            <Switch>
                <Route path={[routes.auth.login, routes.auth.landing]} exact>
                    <Login/>
                </Route>
                <Route path={routes.auth.forgetPassword} exact>
                    <ForgotPassword/>
                </Route>
                <Route path={routes.auth.resetPassword} exact>
                    <ResetPassword/>
                </Route>
                <Route path={routes.auth.logout} exact>
                    <Logout/>
                </Route>
                <Route path={routesLists.authWithServerErrorSection} exact><ServerError/></Route>
                <Route path={routesLists.authWithAccessDeniedSection} exact><AccessDenied/></Route>
                <Redirect to={routes.error.notFound}/>
            </Switch>
        </BaseAuthView>
    );
}

export default AuthViews;
